// @ts-nocheck
import type { Question } from '../types';

export const tramInteractionsQuestions: Question[] = [
  {
    id: 'q-ti-1',
    topic: 'General',
    question: 'You are driving and see a tram approaching from behind. What should you do?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/tram-interactions/q-ti-1-tram-approaching-behind.jpg',
    options: [
      { id: 'q-ti-1o1', text: 'Give way to the tram' },
      { id: 'q-ti-1o2', text: 'Continue driving normally' },
      { id: 'q-ti-1o3', text: 'Speed up to avoid the tram' }
    ],
    answerId: 'q-ti-1o1',
    explanation: 'Trams have priority over other vehicles. You must give way to trams and allow them to pass safely. (RVV 1990 art. 3)',
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-2',
    topic: 'General',
    question: 'You are driving and see a tram stopped at a tram stop. What should you do?',
    animationId: 'ti-anim-1',
    options: [
      { id: 'q-ti-2o1', text: 'Stop and wait for passengers to board/alight' },
      { id: 'q-ti-2o2', text: 'Continue driving past the tram' },
      { id: 'q-ti-2o3', text: 'Honk to warn passengers' }
    ],
    answerId: 'q-ti-2o1',
    explanation: 'When a tram is stopped at a tram stop, you must stop and wait for passengers to safely board or alight before proceeding. (RVV 1990 art. 3)',
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-3',
    topic: 'General',
    question: 'You are driving and see a tram crossing your path. What should you do?',
    options: [
      { id: 'q-ti-3o1', text: 'Give way to the tram' },
      { id: 'q-ti-3o2', text: 'Continue driving, trams must give way' },
      { id: 'q-ti-3o3', text: 'Speed up to cross before the tram' }
    ],
    answerId: 'q-ti-3o1',
    explanation: 'Trams have priority at intersections and crossings. You must give way to trams and wait for them to pass. (RVV 1990 art. 3)',
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-4',
    topic: 'General',
    question: 'You are driving on a road with tram tracks. What should you do?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/tram-interactions/q-ti-4-road-with-tram-tracks.jpg',
    options: [
      { id: 'q-ti-4o1', text: 'Drive carefully and be aware of trams' },
      { id: 'q-ti-4o2', text: 'Drive normally, trams will avoid you' },
      { id: 'q-ti-4o3', text: 'Avoid driving on roads with tram tracks' }
    ],
    answerId: 'q-ti-4o1',
    explanation: 'When driving on roads with tram tracks, drive carefully and be constantly aware of trams that may be approaching. (RVV 1990 art. 3)',
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-7',
    topic: 'General',
    question: 'You are driving and see a tram making a turn. What should you do?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/tram-interactions/q-ti-7-tram-making-turn.jpg',
    options: [
      { id: 'q-ti-7o1', text: 'Give way to the tram' },
      { id: 'q-ti-7o2', text: 'Continue driving, trams must give way' },
      { id: 'q-ti-7o3', text: 'Speed up to avoid the tram' }
    ],
    answerId: 'q-ti-7o1',
    explanation: 'Trams have priority when making turns. You must give way to trams and wait for them to complete their turn. (RVV 1990 art. 3)',
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-8',
    topic: 'General',
    question: 'You are driving and see a tram at a tram stop with passengers boarding. What should you do?',
    animationId: 'ti-anim-1',
    options: [
      { id: 'q-ti-8o1', text: 'Stop and wait for the tram to depart' },
      { id: 'q-ti-8o2', text: 'Continue driving past the tram' },
      { id: 'q-ti-8o3', text: 'Honk to warn passengers' }
    ],
    answerId: 'q-ti-8o1',
    explanation: 'When a tram is at a stop with passengers boarding, you must stop and wait for the tram to depart before proceeding. (RVV 1990 art. 3)',
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-11',
    topic: 'General',
    question: 'You want to turn left across tram tracks. A tram is approaching from the opposite direction. What should you do?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/tram-interactions/q-ti-11-turning-left-across-tracks.jpg',
    options: [
      { id: 'q-ti-11o1', text: 'Give way to the tram; wait until it has passed' },
      { id: 'q-ti-11o2', text: 'Turn quickly before the tram arrives' },
      { id: 'q-ti-11o3', text: 'Honk and then turn' }
    ],
    answerId: 'q-ti-11o1',
    explanation: 'When turning across tram tracks, you must give way to trams. Wait until the tram has passed before completing your turn. (RVV 1990 art. 3)',
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-12',
    topic: 'General',
    question: 'You are at a junction. A tram is approaching from your right. Who has priority?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/tram-interactions/q-ti-12-junction-tram-priority.jpg',
    options: [
      { id: 'q-ti-12o1', text: 'You have priority; priority to the right does not apply to trams' },
      { id: 'q-ti-12o2', text: 'The tram has priority; you must give way' },
      { id: 'q-ti-12o3', text: 'Whoever arrives first has priority' }
    ],
    answerId: 'q-ti-12o2',
    explanation: 'Trams have priority at junctions over other traffic. You must give way to the tram approaching from your right. (RVV 1990 art. 3)',
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-13',
    topic: 'General',
    question: 'You are driving in a lane shared with tram tracks. A tram is behind you. What should you do?',
    options: [
      { id: 'q-ti-13o1', text: 'Speed up to stay ahead of the tram' },
      { id: 'q-ti-13o2', text: 'Allow the tram to pass when safe; move aside if possible or continue at a steady speed' },
      { id: 'q-ti-13o3', text: 'Stop immediately in the lane' }
    ],
    answerId: 'q-ti-13o2',
    explanation: 'In a shared lane, allow the tram to pass when it is safe. If you can move aside without endangering others, do so; otherwise continue at a steady speed so the tram can follow or pass when the road widens. (RVV 1990 art. 3)',
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-14',
    topic: 'General',
    question: 'A tram has stopped at a stop in the middle of the road. Passengers are crossing to the pavement. What should you do?',
    options: [
      { id: 'q-ti-14o1', text: 'Stop and wait until the tram moves and the crossing is clear' },
      { id: 'q-ti-14o2', text: 'Drive past slowly; pedestrians must wait' },
      { id: 'q-ti-14o3', text: 'Honk so pedestrians hurry' }
    ],
    answerId: 'q-ti-14o1',
    explanation: 'When a tram has stopped and passengers are crossing the road to or from the tram, you must stop and wait until they have crossed and the tram has moved off if necessary. (RVV 1990 art. 3)',
    animationId: 'ti-anim-1',
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-16',
    topic: 'General',
    question: 'At a junction, the traffic lights are green for you. A tram is also approaching the junction and has a green light. What should you do?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/tram-interactions/q-ti-16-traffic-lights-tram-priority.jpg',
    options: [
      { id: 'q-ti-16o1', text: 'Proceed; you both have green' },
      { id: 'q-ti-16o2', text: 'Give way to the tram; trams have priority when both have green' },
      { id: 'q-ti-16o3', text: 'Stop and wait for the tram to pass' }
    ],
    answerId: 'q-ti-16o2',
    explanation: 'When you and a tram both have a green light, the tram has priority. You must give way to the tram before proceeding. (RVV 1990 art. 3)',
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-17',
    topic: 'General',
    question: 'You are waiting to turn right. A tram is going straight ahead on the same road. Who has priority?',
    options: [
      { id: 'q-ti-17o1', text: 'You have priority when turning right' },
      { id: 'q-ti-17o2', text: 'The tram has priority; you must give way' },
      { id: 'q-ti-17o3', text: 'Whoever moves first has priority' }
    ],
    answerId: 'q-ti-17o2',
    explanation: 'Trams going straight ahead have priority over vehicles turning. You must wait for the tram to pass before turning right. (RVV 1990 art. 3)',
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-18',
    topic: 'General',
    question: 'A tram is reversing into a depot. What should you do?',
    options: [
      { id: 'q-ti-18o1', text: 'Give way and wait; do not pass the reversing tram' },
      { id: 'q-ti-18o2', text: 'Pass quickly before it blocks the road' },
      { id: 'q-ti-18o3', text: 'Honk to warn the tram driver' }
    ],
    answerId: 'q-ti-18o1',
    explanation: 'When a tram is reversing, give way and wait. Do not try to pass; wait until the tram has completed its manoeuvre. (RVV 1990 art. 3)',
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-21',
    topic: 'General',
    question: 'A tram has just left a stop and is moving slowly. You are behind it. What should you do?',
    options: [
      { id: 'q-ti-21o1', text: 'Overtake as soon as possible' },
      { id: 'q-ti-21o2', text: 'Stay behind at a safe distance; do not overtake unless the tram has stopped or you have a clear dedicated lane' },
      { id: 'q-ti-21o3', text: 'Honk to make it go faster' }
    ],
    answerId: 'q-ti-21o2',
    explanation: 'Do not overtake a tram that has just left a stop until it is safe and allowed. Passengers may still be near the road; the tram may stop again. Keep a safe distance. (RVV 1990 art. 3)',
    subject: 'Tram Interactions'
  },
];






